import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import classNames from "classnames";

const MUIButton = ({
  children,
  color = "primary",
  className,
  disabled = false,
  endIcon,
  isFixed = false,
  onClick,
  size,
  startIcon,
  type,
  variant = "text",
  sx,
  isHidden = false,
  ...props
}) => {
  const isFixedStyling = isFixed
    ? {
        position: "fixed",
        bottom: { xs: "1rem", md: "2rem" },
        right: { xs: "1rem", md: "10rem" },
      }
    : "";

  const isButtonHidden = isHidden ? { display: "none" } : "";

  return (
    <Button
      color={color}
      disabled={disabled}
      endIcon={endIcon}
      size={size}
      startIcon={startIcon}
      type={type}
      variant={variant}
      className={classNames(className)}
      onClick={onClick}
      sx={{
        minWidth: "6.625rem",
        minHeight: "2.375rem",
        my: "0.5rem",
        zIndex: 20,
        ...isFixedStyling,
        ...isButtonHidden,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

MUIButton.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "inherit",
    "primary",
    "secondary",
    "success",
    "error",
    "info",
    "warning",
  ]),
  disabled: PropTypes.bool,
  endIcon: PropTypes.node,
  isFixed: PropTypes.bool,
  isHidden: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.string,
  startIcon: PropTypes.node,
  sx: PropTypes.object,
  type: PropTypes.string,
  variant: PropTypes.string,
};

export default MUIButton;
